import apiClient from "services/apiClient";

async function addObject(data: any) {
  const url = `/admin/objects`;
  const res = await apiClient.post(url, data);
  return res.data;
}

export default addObject;
